import React from "react";
import CustomAlert from "../CustomComponents/CustomAlert/CustomAlert";
import {
  CustomCloseIcon,
  CustomCheckCircleIcon,
} from "../CustomComponents/CustomIcon/CustomIcon";
import { useHistory } from "react-router-dom";
import { getSession, logOutUser } from "../../services/LocalStorageService";
import { useStyles } from "../../assets/jss/ErrorAlert";
import { useTranslation } from "react-i18next";
import errorToast from "../../assets/images/errorToast.png";

const ErrorAlert = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { code, message, isOpen, description, alertType } = props;
  const history = useHistory();
  const [messageText, setMessageText] = React.useState(message);
  const [statusCode, setStatusCode] = React.useState(code);
  const [isOpenAlert, setIsOpenAlert] = React.useState(isOpen);
  const [alertDescription, setAlertDescription] = React.useState(description);
  const [type, setType] = React.useState(alertType);
  const [userSession] = React.useState(getSession);
  const [alertHideDuration] = React.useState(3000);

  React.useEffect(() => {
    setStatusCode(code);
    setMessageText(message);
    setIsOpenAlert(isOpen);
    setAlertDescription(description);
    setType(alertType);
  }, [isOpen]);

  const reloadWindow = () => {
    window.location.reload();
  };

  const onClose = () => {
    setStatusCode(null);
    setMessageText("");
    setIsOpenAlert(false);
    if (props.isClose) {
      props.isClose(true);
    }
    if (statusCode === 401 || statusCode === 1010) {
      userSession && logOutUser();
      // history.push("/login");
      history.push("/login", { from: history.location });
    }
  };

  return (
    <CustomAlert
      className={classes.errorAlert}
      open={isOpenAlert}
      icon={type === "success" ? <CustomCheckCircleIcon fontSize="large" /> : <img src={errorToast} />}
      autoHideDuration={alertHideDuration}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      alertseverity={type ? type : "error"}
      onClose={() => onClose()}
    >
      <div className={classes.alertWrap}>
        <div className={classes.message}>
          {messageText}
          <br />
          {(statusCode === 401) &&
            t("REDIRECTING_TO_LOGIN_PAGE")}

          {alertDescription ? (
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: alertDescription }}
            ></div>
          ) : null}
        </div>
        {statusCode !== 403 &&
          statusCode !== 401 &&
          statusCode !== 0 &&
          statusCode !== 200 &&
          statusCode !== 201 && (
            <>
              <div className={classes.action}>
                <span className={classes.actionBtn} onClick={reloadWindow}>
                  {t("REFRESH")}
                </span>
              </div>
              <div className={classes.action}>
                <span className={classes.actionClose} onClick={onClose}>
                  <CustomCloseIcon fontSize="large" />
                </span>
              </div>
            </>
          )}
      </div>
    </CustomAlert>
  );
};

export default ErrorAlert;
